// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchCompleteSignIn } from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { customPardotSignInApi } from "@mcmc/App/Services/CustomPardotSignIn";
import { getSettingsCollection } from "@mcmc/App/Store/Selectors/SettingsSelectors";

// XNG-Changes XSD-13084
export const XngDispatchCompleteSignIn: typeof DispatchCompleteSignIn = async (props) => {
    const state = props.getState();
    const { pardotIntegrationType, loginSubmitNotification } = getSettingsCollection(state).customSettings;
    const isPardotIntegration = pardotIntegrationType?.toLowerCase() === "pardot";

    if (!isPardotIntegration || props.apiResult?.error_description?.length) {
        return;
    }

    try {
        await customPardotSignInApi(loginSubmitNotification, {
            email: props.parameter.userName,
        });
    } catch (e) {
        props.parameter.onError?.(e && ((e.errorJson && e.errorJson.message) || e.errorMessage || e.message || e));
    }
};

addToChainAfter(chain, DispatchCompleteSignIn, XngDispatchCompleteSignIn);
